import SelectInput from "../../../components/SelectInput";
import {MatchStatus} from "../../../constants";
import {useTranslation} from "react-i18next";
import React from "react";
import FeatherIcon from "feather-icons-react";
import {Form} from "react-bootstrap";

export const MatchStatusSelect = ({ match, is_authorized, onSave, min_height=false, loader=false }) => {
    const { t } = useTranslation();

    if (!is_authorized) {
        return <span style={{marginLeft: "auto"}}>{match?.status ? t(MatchStatus[match.status]) : ""}</span>
    }

    const statusData = Object.entries(MatchStatus).map(([id, name]) => ({
        id: Number(id),
        name: name
    }));

    const content = (
        <div className={`matches-status-select ${loader ? "status-loader" : ""}`}>
            {loader ?
                <div className="relative input">
                    <div className="custom_select">
                        <div className="select_arrow">
                           <center><FeatherIcon icon="loader"  /></center>
                        </div>
                        <p>&nbsp;...</p>
                        <input type="text" style={{ display: "none" }} />
                    </div>
                </div>
                :
                <SelectInput
                    data={statusData}
                    default_value={match?.status}
                    default_text={match?.status ? MatchStatus[match.status] : t("Choose match status")}
                    setInputValue={(newStatus) => {
                        const payload = {status: newStatus};
                        if (![5, 6, 7].includes(newStatus)) {
                            payload.winner_side = null;
                        }
                        onSave(payload);
                    }}
                    show_label={false}
                />}
        </div>
    );

    return min_height
        ? <div style={{ minHeight: "28px" }}>{content}</div>
        : content;
};
